$(document).ready(function(){
  var footerHeight = $('.fixed-footer').outerHeight();
  $('body').css('padding-bottom', footerHeight + 15);
});
$(document).ready(function(){
  $('.black-layout').hide();
  $('.menu').click(function(){
    $('.black-layout').show();
    $('.hamburger-menu').addClass('show-menu');
    $('body').css('overflow', 'hidden');
  });
  $('.close-hamburger').click(function(){
    $('.black-layout').hide();
    $('.hamburger-menu').removeClass('show-menu');
    $('body').css('overflow', 'auto');
  });
  $('.fly-msg').click(function(){
    $('#message1').toggleClass('in');
    setTimeout(function() {$('#message1').toggleClass('in');}, 3000);
  });
});

// $(document).ready(function() {
//   $('.menu-list>li>router-link').click(function(){
//       $('.black-layout').show();
//   });
// })


//////////////////
// WEBPACK FOOTER
// ./static/js/mobile/custom.js
// module id = b1zr
// module chunks = 4